// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"782dcafc","127":"7dc950a6","164":"2e12a62e","193":"2a6668fe","274":"5960f0b8","304":"031c85ec","389":"cc7256c3","787":"cf01e9c7","789":"d132948f"}[chunkId] + ".chunk.js";
};